<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Preston has a bachelor’s degree in Criminal Justice from the University of Houston-Downtown. He also has a patent on shoulder weights he designed in the 1980s. He is a father and a grandfather and about to start traveling internationally.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?5130f799